import { useCallback, useEffect, useState } from 'react'
import { api } from '../api/client.js'

export interface Timezone {
  id: string
  label: string
  value: string
  createdAt: string
}

export interface UseTimezonesResult {
  items: Timezone[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useTimezones(): UseTimezonesResult {
  const [items, setItems] = useState<Timezone[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [fetchKey, setFetchKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    api.get<{ timezones: Timezone[] }>('/platform/timezones')
      .then((res) => {
        if (!cancelled) setItems(res.timezones ?? [])
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Error fetching timezones')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [fetchKey])

  const refetch = useCallback(async () => {
    setFetchKey((k: number) => k + 1)
  }, [])

  return { items, loading, error, refetch }
}
